import { IEnumModel } from './../../../models/enum.model';
import { ModalVisualizarRespostaComponent } from './modal-visualizar-resposta/modal-visualizar-resposta.component';
import { IncluirSolicitacaoComponent } from './modal-incluir-solicitacao/modal-incluir-solicitacao.component';
import { ModalJustificativaComponent } from './../modal-justificativa/modal-justificativa.component';
import { SolicitacaoTecnicaService } from "./../../../services/solicitacao-tecnica.service";
import { ISolicitacaoTecnicaModel } from "./../../../models/solicitacao-tecnica.model";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import Swal from "sweetalert2";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './../../../services/auth.service';
import { EnumRecursoPerfil } from './../../../models/enum/recurso-perfil.enum';
import { EnumAcaoRecurso } from './../../../models/enum/acao-recurso.enum';
import { ModalAvaliarProrrogacaoComponent } from './modal-avaliar-prorrogacao/modal-avaliar-prorrogacao.component';
import { IPlanejamentoModel } from '../../../models/planejamento.model';
import { PlanejamentoService } from "./../../../services/planejamento.service";
import { ModalResponderSolicitacaoComponent } from './modal-responder-solicitacao/modal-responder-solicitacao.component';

@Component({
	selector: "app-aba-solicitacao-tecnica",
	templateUrl: "./aba-solicitacao-tecnica.component.html",
	styleUrls: ["./aba-solicitacao-tecnica.component.scss"],
})
export class AbaSolicitacaoTecnicaComponent implements OnInit {
	public displayedColumns: string[] = [
		"selecao",
		"numero",
		"assunto",
		"prazo",
		"tipo",
		"ug",
		"responsavel",
		"status",
		"resposta",
	];
	public dataSource = new MatTableDataSource<ISolicitacaoTecnicaModel>([]);
	public semDados = true;
	public selectedModel: ISolicitacaoTecnicaModel;
	public permitido: boolean = false;
	public dataVencida: boolean;
	public tipotrabalhoId: number;
	@Input() numeroOpa: string;
	public tipoTrabalho: IEnumModel = {} as IEnumModel;
	@Input() visualizar: boolean;
	@Input() planejamentoId: number;
	public podePlanejar: boolean = false;
	public podeCancelarSolicitacao: boolean = false;
	public podeCancelarItem: boolean = false;
	public podeRespSolExterna: boolean = false;
	public podeApreciarProrrogacao: boolean = false;
	public podeHabilitarResposta: boolean = false;
	public podeAvaliarResposta: boolean = false;
	public podeImprimir: boolean = false;
	dataAtual = new Date();
	public planejamento: IPlanejamentoModel;

	constructor(
		private solicitacaoTecnicaService: SolicitacaoTecnicaService,
		private planejamentoService: PlanejamentoService,
		private matDialog: MatDialog,
		public router: Router,
		public route: ActivatedRoute,
		public authService: AuthService,
	) {
		this.tipotrabalhoId = +this.route.snapshot.paramMap.get("id");

		if (this.router.url.includes("planejamento")) {
			this.tipoTrabalho.nome = 'planejamento';
			this.tipoTrabalho.codigo = 7;
		}
		if (this.router.url.includes("osa")) {
			this.tipoTrabalho.nome = 'osa';
			this.tipoTrabalho.codigo = 4;
		}
	}

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;


	ngOnInit(): void {
		this.setarPermissoes();
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
		this.obter();
		this.obterPlanejamento();
	}

	private setarPermissoes(): void {
		this.podePlanejar = this.authService.possuiPermissao(EnumRecursoPerfil.Planejamento, EnumAcaoRecurso.Planejar);
		this.podeImprimir = this.authService.possuiPermissao(EnumRecursoPerfil.Planejamento, EnumAcaoRecurso.Imprimir);
	}

	private formatarDocumentoAssociado(numeroOpa: string): string {
		return numeroOpa ? `OPA ${numeroOpa}` : '';
	}

	public obter() {
		console.log(this.tipotrabalhoId);
		console.log(this.tipoTrabalho?.nome);
		this.solicitacaoTecnicaService
			.obter(this.tipotrabalhoId, this.tipoTrabalho?.nome)
			.then((res) => {

				if (res.dados) {
					this.dataSource = new MatTableDataSource<ISolicitacaoTecnicaModel>(res.dados);
					this.semDados = this.dataSource.filteredData.length === 0;
					this.dataSource.paginator = this.paginator;
					this.dataSource.sort = this.sort;
					this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
					this.selectedModel = null
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: err.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			});
	}

	public obterPlanejamento() {
		this.planejamentoService
			.obterPorId(this.tipotrabalhoId)
			.then((pla) => {
				this.planejamento = pla.dados;
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: err.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			});
	}


	public selecionar(item: any) {

		this.selectedModel =
			!this.selectedModel || this.selectedModel.id !== item.id
				? item
				: null;

		if (this.selectedModel?.status?.codigo === 1 || this.selectedModel?.status?.codigo === 2) {
			this.permitido = true;
		} else {
			this.permitido = false;
		}

		if (new Date(this.selectedModel?.prazo) < new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate())) {
			this.dataVencida = true;
		}

		this.podeCancelarSolicitacao = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 5 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
		this.podeCancelarItem = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
		this.podeRespSolExterna = (this.podePlanejar) && (this.selectedModel?.tipo == 2) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 5 || this.selectedModel?.status.codigo == 6 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
		this.podeApreciarProrrogacao = (this.podePlanejar) && (this.selectedModel?.status.codigo == 5);
		this.podeHabilitarResposta = (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8) && (this.dataVencida);
		this.podeAvaliarResposta = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 5 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
	}

	public imprimir(element: ISolicitacaoTecnicaModel) {
		this.router.navigateByUrl(`${this.tipoTrabalho}/${this.tipotrabalhoId}/solicitacao-tecnica/${element?.id}/imprimir`)
	}

	public sortingDataAccessor = (item, property) => {
		switch (property) {
			case "prazo":
				return item?.prazo;
			case "status":
				return item?.status?.descricao;
			case "ug":
				return item?.internaUnidadeGestora?.sigla;
			case "assunto":
				return item?.assunto;
			case "responsavel":
				return item?.internaResponsavel?.nome;
			default:
				return item[property];
		}
	};

	public incluirSolicitacaoTecnica(titulo: string, visualizar?: boolean, selectedModel?: ISolicitacaoTecnicaModel): void {

		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component-solicitacao-tecnica';
		dialogConfig.width = '80%';
		dialogConfig.height = '90%';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			titulo,
			element: selectedModel,
			id: selectedModel?.id,
			status: selectedModel?.status,
			visualizar,
			acaoCancelarItem: false,
			tipoTrabalhoId: this.tipotrabalhoId,
			planejamentoId: this.planejamentoId,
			documentoAssociado: this.formatarDocumentoAssociado(this.numeroOpa),
			tipoTrabalho: this.tipoTrabalho,
			numeroST: selectedModel?.numero,
			dataLimite: this.planejamento?.opa?.dataFimRealizacao ? new Date(this.planejamento?.opa?.dataFimRealizacao) : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
		};

		const modal = this.matDialog.open(
			IncluirSolicitacaoComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data) {
			}
			this.obter()
		});
	}

	public modalVisualizarResposta(id: number): void {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component-resposta';
		dialogConfig.width = '60%';
		dialogConfig.height = 'auto';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {
			titulo: 'Visualizar Resposta',
			id: id,
		};

		const modal = this.matDialog.open(
			ModalVisualizarRespostaComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data) {
			}
		});
	}

	public cancelarSolicitacao(id: number) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component';
		dialogConfig.width = '45vw';
		dialogConfig.maxHeight = '85vh';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {
		}
		const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
		modal.afterClosed().subscribe(justificativa => {
			if (justificativa) {

				const responsavelId = this.authService.usuario.id;

				this.solicitacaoTecnicaService.cancelarSolicitacao(id, justificativa, responsavelId)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					}).catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							icon: "error",
							text: err.mensagem.descricao,
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					}).finally(() => {
						this.obter()
					});
			}
		});
	}

	public excluir(id: number) {
		Swal.fire({
			title: "Excluir Registro",
			text: "Tem certeza que deseja excluir esse Registro?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim",
			cancelButtonText: "Não",
		}).then((res) => {
			if (res.value) {
				this.solicitacaoTecnicaService
					.excluir(id)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					})
					.catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							text: err.mensagem.descricao,
							icon: "error",
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					}).finally(() => {
						this.obter()
					}
					);
			}
		});
	}


	//#region botao Preencimento

	public cancelarItem(selectedModel?: ISolicitacaoTecnicaModel): void {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component-solicitacao-tecnica';
		dialogConfig.width = '80%';
		dialogConfig.height = '90%';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			titulo: "Cancelar Item da",
			element: selectedModel,
			id: selectedModel?.id,
			status: selectedModel?.status,
			visualizar: true,
			acaoCancelarItem: true,
			tipoTrabalhoId: this.tipotrabalhoId,
			planejamentoId: this.planejamentoId,
			documentoAssociado: this.formatarDocumentoAssociado(this.numeroOpa),
			tipoTrabalho: this.tipoTrabalho,
			numeroST: selectedModel?.numero,
			dataLimite: this.planejamento?.opa?.dataFimRealizacao ? new Date(this.planejamento?.opa?.dataFimRealizacao) : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
		};

		const modal = this.matDialog.open(
			IncluirSolicitacaoComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data) {
			}
			this.obter()
		});
	}

	public responderSTExterna(selectedModel?: ISolicitacaoTecnicaModel) {

		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component-responder-solicitacao-tecnica';
		dialogConfig.width = '80%';
		dialogConfig.height = '90%';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			responder: true,
			avaliar: false,
			titulo: "Responder",
			element: selectedModel,
			id: selectedModel?.id,
			status: selectedModel?.status,
			visualizar: true,
			tipoTrabalhoId: this.tipotrabalhoId,
			planejamentoId: this.planejamentoId,
			documentoAssociado:  this.formatarDocumentoAssociado(this.numeroOpa),
			tipoTrabalho: this.tipoTrabalho,
			numeroST: selectedModel?.numero,
			dataLimite: this.planejamento?.opa?.dataFimRealizacao ? new Date(this.planejamento?.opa?.dataFimRealizacao) : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
		};

		const modal = this.matDialog.open(
			ModalResponderSolicitacaoComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data) {
			}
			this.obter()
		});
	}


	public apreciarProrrogacao(element: ISolicitacaoTecnicaModel) {

		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component";
		dialogConfig.width = "45vw";
		dialogConfig.maxHeight = "85vh";
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			solicitacaoId: element?.id,
			data: element?.tipo == 1 ? element?.prorrogarSolicitacao?.data : new Date(),
			justificativa: element?.prorrogarSolicitacao.justificativa,
			dataLimiteProrrogacao: this.planejamento?.opa?.dataFimRealizacao ? new Date(this.planejamento?.opa?.dataFimRealizacao) : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
		};
		const modal = this.matDialog.open(
			ModalAvaliarProrrogacaoComponent,
			dialogConfig
		);
		modal.afterClosed().subscribe((data) => {
			this.obter()
		});
	}

	public habilitarResposta(id: number, prazo: Date) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component';
		dialogConfig.width = '45vw';
		dialogConfig.maxHeight = '85vh';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {
		}
		const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
		modal.afterClosed().subscribe(data => {
			if (data) {
				this.solicitacaoTecnicaService.habilitarRespostaSolicitacao(id, data, prazo)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					}).catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							icon: "error",
							text: err.mensagem.descricao,
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					}).finally(() => {
						this.obter()
					});
			}
		});
	}

	public avaliarResposta(selectedModel?: ISolicitacaoTecnicaModel) {

		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component-responder-solicitacao-tecnica';
		dialogConfig.width = '80%';
		dialogConfig.height = '90%';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			responder: false,
			avaliar: true,
			titulo: "Avaliar Resposta da",
			element: selectedModel,
			id: selectedModel?.id,
			status: selectedModel?.status,
			visualizar: true,
			tipoTrabalhoId: this.tipotrabalhoId,
			planejamentoId: this.planejamentoId,
			documentoAssociado: this.formatarDocumentoAssociado(this.numeroOpa),
			tipoTrabalho: this.tipoTrabalho,
			numeroST: selectedModel?.numero,
			dataLimite: this.planejamento?.opa?.dataFimRealizacao ? new Date(this.planejamento?.opa?.dataFimRealizacao) : new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
		};

		const modal = this.matDialog.open(
			ModalResponderSolicitacaoComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data) {
			}
			this.obter()
		});
	}

	//#endregion


	formatarTooltipCanc(element: any): string {

		const data = element?.dataHoraCanc
			? new Date(element.dataHoraCanc).toLocaleDateString('pt-BR')
			: 'Data não informada';

		const nome = element?.responsavelCanc?.nome || 'Usuário desconhecido';
		const comentario = element?.justificativa || 'Sem comentário';

		return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
	}

}
